
import { apiFuns } from "sw-hic";
let { get, post, put, del, genStandard } = apiFuns;
let api = {
    DeptRoom: {
    ...genStandard("deptRoom", "/api/md"),
  }
};
export default api;
